<template>
  <div class="open-module">
    <!--标题栏-->
    <app-header class="app-header" title="功能开通" @goback="goBack">
      <div slot="tips" @click="goToOpenOrder">
        <div class="open-text">{{`申请开通(${shoppingCart.length})`}}</div>
      </div>
    </app-header>
    <!-- 模块切换 -->
    <div class="module-select" @click="openModule">
      <span>{{currentModule.text}}</span><i class="iconfont iconxiala"></i>
    </div>
    
    <ul class="module-box">
      <pull-to>
        <li v-for="(item, index) in productList" :key="index">
          <module-list :data="item" @select="addToOrder($event, item, index)"></module-list>
        </li>
      </pull-to>
    </ul>
    
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import PullTo from 'vue-pull-to';
import AppHeader from 'components/app-header';
import moduleList from './components/module-list';
import apis from 'api/index';
import { mapGetters, mapMutations } from 'vuex';

export default {
  mixins: [commonMixin],
  components: {
    AppHeader,
    moduleList,
    PullTo,
  },
  data() {
    return {
      modulesList: [], // 模块列表
      currentModule: {},
      productList: [], // 产品列表
    }
  },
  computed: {
    ...mapGetters(['shoppingCart'])
  },
  created() {
    this.fetchModuleList().then(res => {
      this.modulesList = this._normalizeModule(res);
      this.currentModule = this.modulesList[0];
      this.fetchProductByModule();
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToOpenOrder() {
      this.$router.push({name: 'open-confirm'});
    },
    // 打开选择pop
    openModule() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '选择模块',
          data: [this.modulesList],
          onSelect: this.changeModule,
        })
      }
      this.picker.show();
    },
    // 切换模块
    changeModule(value) {
      this.currentModule = this.modulesList.filter(item => item.value === value[0])[0];
      this.fetchProductByModule();
    },
    // 选中产品添加到购物车，并存到state里,将product的hasSelect变成1
    addToOrder($event, product, index) {
      this.productList[index].hasSelect = 1;
      this.productList[index] = Object.assign({}, this.productList[index], $event);
      // // this.$set(this.productList[index], hasSelect, 1);
      this.setShoppingCart(this.productList[index]);
    },
    // 获取模块下的产品列表
    async fetchProductByModule() {
      try {
        const res = await apis.getModuleProductList({moduleId: this.currentModule.id});
        this.productList = this._normalizeProduct(res);
      } catch(err) {
        console.error(err);
      }
    },
    // 主要是解决按钮的置灰问题，给按钮安排一个字段,如果购物车里有就置灰
    _normalizeProduct(data) {
      data.forEach(item => {
        let index = this.shoppingCart.findIndex(product => product.id === item.id);
        if(index !== -1) {
          item.hasSelect = 1;
          item.storeNumber = this.shoppingCart[index].storeNumber;
          item.duration = this.shoppingCart[index].duration;
        } else {
          item.hasSelect = 0;
        }
      });
      return data;
    },
    ...mapMutations(['setShoppingCart'])
  },
}
</script>

<style lang="scss" scoped  src="./open.scss"></style>

<style lang="scss" scoped>
// 功能开通
// .open-module{
//   .open-text {
//     color: #ff9900;
//     font-size: 15px;
//   }
// }
</style>


